import {Fragment, PureComponent} from 'react'

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx'

import chroImg from '../../../media/images/sub-universes/hr/chro.jpg?size=600'
import headerImg from '../../../media/images/universes/hr.jpg'
import payrollImg from '../../../media/images/sub-universes/hr/payroll.jpg?size=600'
import socialRelationsImg from '../../../media/images/sub-universes/hr/socialRelations.jpg?size=600'

const headerBrief = <Fragment>
  <p>Twineeds mobilise un <strong>réseau de consultants RH</strong> pour répondre à vos enjeux : <strong>mission ponctuelle, transformation, structuration de la fonction RH ou management de transition</strong>.</p>
  <p>Nos profils sont disponibles rapidement pour <strong>accompagner vos projets, partout en France</strong>. Déposez votre besoin, nous vous proposons un expert RH adapté à votre organisation.</p>
</Fragment>

const title = "Renforcez vos équipes | Consultants RH spécialisés"
const description = "Accelérez vos projets RH avec des consultants experts et profils qualifiés : ressources humaines, paie, relation sociale, droit social, SIRH et recrutement."

const ourJobsItems = [
  {
    title: 'Direction des Ressources Humaines',
    brief: '<p>Des <strong>experts métier</strong> mobilisables pour <strong>renforcer la performance de votre direction RH</strong>.</p>' +
      '<p>L’ensemble des postes liés à cette fonction: <strong>responsable RH, directeur ressources humaines, responsable développement RH, DRH</strong>, etc.</p>',
    img: chroImg.src,
    imgAlt: 'Poignée de main entre consultant expert et professionnel'
  },
  {
    title: 'Gestion de la paie / SIRH',
    brief: '<p>Des <strong>experts paie & SIRH</strong> pour piloter vos fonctions support : <strong>responsable paie, responsable SIRH, directeur paie</strong>, etc.</p>',
    img: payrollImg.src,
    imgAlt: 'Outils d\'un consultant en gestion de paie'
  },
  {
    title: 'Affaires sociales',
    brief: '<p>Des <strong>experts RH spécialisés en droit social : responsable relations sociales, responsable affaires sociales, expert droit du travail</strong>, etc.</p>',
    img: socialRelationsImg.src,
    imgAlt: 'Une entreprise écoute les conseils d\'un consultant RH'
  }
]

const specificDifference = <Fragment><strong>Un réseau de consultants spécialisés</strong> pour structurer vos projets transverses et accompagner le changement.</Fragment>

export default class LandingCompanyHr extends PureComponent {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      headerImgAlt="Consultante experimentée conseille une entreprise devant un PC"
      helmet={{title, description}}
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Besoin d'un profil spécialisé en RH ? Accédez à notre réseau d'indépendants qualifiés"
      universeCode="hr"
    />
  }
}
